import type { IngestProject } from '../../../../domain/src/lib/ingest/ingest-project.model';

/** Mensaje estándar: expediente inactivo en modo solo consulta (sin ingesta ni cambios). */
export const INGEST_INACTIVE_PROJECT_READ_ONLY_MESSAGE =
  'Este expediente está inactivo. Solo puede consultar la información existente. Actívelo desde la lista de expedientes para cargar documentos o crear subcarpetas.';

/** @deprecated Usar INGEST_INACTIVE_PROJECT_READ_ONLY_MESSAGE */
export const INGEST_INACTIVE_PROJECT_UPLOAD_MESSAGE = INGEST_INACTIVE_PROJECT_READ_ONLY_MESSAGE;

export function isIngestProjectEligibleForUpload(
  project: Pick<IngestProject, 'is_active'> | null | undefined,
): boolean {
  return project?.is_active === true;
}

export function ingestInactiveProjectMessage(projectName?: string | null): string {
  const name = projectName?.trim();
  if (!name) {
    return INGEST_INACTIVE_PROJECT_READ_ONLY_MESSAGE;
  }
  return `El expediente «${name}» está inactivo. Solo puede consultar la información existente. Actívelo desde la lista de expedientes para cargar documentos o crear subcarpetas.`;
}

/** @deprecated Usar ingestInactiveProjectMessage */
export function ingestInactiveProjectUploadMessage(projectName?: string | null): string {
  return ingestInactiveProjectMessage(projectName);
}

export function filterIngestActiveProjects(projects: IngestProject[]): IngestProject[] {
  return projects.filter((project) => isIngestProjectEligibleForUpload(project));
}
